module.exports = {"forgot_pass":"Forgot your password?","return":"Return","find_availability":"Click to find availability"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/en/links.json
// module id = 723
// module chunks = 18